import { useAppDispatch, useAppSelector } from 'app/hooks';
import { closeReassign, closeTextEdit } from 'app/slices/projectBoardSlice';
import ProjectMainForm from './ProjectMainForm';
import ReassignPopup from './ReassignPopup';
import TextEditPopup from './TextEditPopup';
import AhuListPanel from './ahus/AhuListPanel';

/**
 * General Info tab composite (#project mount — ProjectCompositeView →
 * project/tmpl/project.tmpl), inventory §3.8. Exact static 2-column layout:
 * left column hosts the ProjectMainForm (`.main-inputs` mount) plus the
 * #reassign_popup / #text_edit_popup mounts; the right column is the
 * `#main_ahus` AHU-list mount (sub-phase 3b — AhuListPanel, inventory Part B
 * §B1). The composite-level #new_ahu_popup mount stays empty: the shared
 * popup targets the FIRST `#new_ahu_popup` in DOM order, which is the one
 * inside #main_ahus (ahus.tmpl) — the panel owns it.
 *
 * [NEG] honored: the never-attached `.table-wrapper` scroll handler (parity
 * 60) and the empty `view.project_ahu`/`new_ahu` modules (parity 59) are not
 * rebuilt.
 */
const GeneralInfoTab = ({ projectId }: { projectId: number }) => {
  const dispatch = useAppDispatch();
  const reassignOpen = useAppSelector((s) => s.projectBoard.modals.reassign);
  const textEdit = useAppSelector((s) => s.projectBoard.modals.textEdit);

  return (
    <div id="proposal" className="full-height user_settings">
      <div className="full-height">
        <div className=" full-height">
          <div className="row full-height">
            <div className="project-project col-xs-4 full-height left-column proposal-content-oproposal-format padding-left-0">
              <div className="content-item full-height">
                <div className="list-inline main-inputs w-100 h-100">
                  <ProjectMainForm projectId={projectId} />
                </div>
                <div id="reassign_popup">
                  {reassignOpen && (
                    <ReassignPopup
                      projectId={projectId}
                      onClose={() => dispatch(closeReassign())}
                    />
                  )}
                </div>
                <div id="text_edit_popup">
                  {textEdit && (
                    <TextEditPopup
                      projectId={projectId}
                      name={textEdit.name}
                      onClose={() => dispatch(closeTextEdit())}
                    />
                  )}
                </div>
              </div>
            </div>
            {/* AHU list (sub-phase 3b — inventory Part B §B1) */}
            <div className="col-xs-8 full-height" id="main_ahus">
              <AhuListPanel projectId={projectId} />
            </div>
          </div>
        </div>
      </div>
      <div id="new_ahu_popup" />
    </div>
  );
};

export default GeneralInfoTab;
